import type { SoundSpriteDefinitions } from 'howler';

// export const WEBPACK_HASH = String(__webpack_hash__);
export const LAST_PLAYED_SECTION_NAME = 'LAST_PLAYED';
export const LAST_PLAYED_STORAGE_KEY = 'egtd_last_played';
export const LOBBY_SECTION_NAME = 'LOBBY';
export const TOURNAMENTS_SECTION_NAME = 'TOURNAMENTS';
export const PRICE_POP_SECTION_NAME = 'PRIZE_POP';
export const REBATE_SECTION_NAME = 'REBATE';
export const HOT_AND_COLD_SECTION_NAME = 'HOT_AND_COLD';
export const FAVORITE_SECTION_NAME = 'FAVORITES';
export const LOCAL_STORAGE_FAVORITE_KEY = 'favourite';
export const MODAL_TYPES = {
  TOURNAMENT: 'tournament',
  INFO_TERMS: 'info_terms',
};
export const OPEN_TYPES = {
  INGAME: 'ingame',
  FULLSCREEN: 'fullscreen',
};
export const EXTERNAL_EVENTS = {
  BALANCE: 'balance',
  DISPLAY: 'display',
  DEFENSE_CODE: 'defenceCode',
  MUTE: 'mute',
  BG_MUSIC_MUTE: 'bgMusicMute',
  SETTINGS: 'settings',
  HOME_CLICK: 'homeClick',
};
export const JP_STAT_UPDATE_FPS: number = 20;
export const FETCH_JP_STAT_INTERVAL_SECONDS: number = 10; // keep this above 8 as server has threshold on updating values
export const SCROLL_POS_STORAGE_KEY = 'egtd_lobby_scroll_possitions';
export const RIGHT_SCROLL_OFFSET = 10;
export const SOUND_SPRITES: SoundSpriteDefinitions = {
  exitAppSound: [0, 716.235827664399],
  hoverSound: [1500, 109.50113378684811],
  selectGameSound: [3000, 798.3446712018143],
  selectTabSound: [4500, 328.48072562358243],
  silent: [6000, 342.1541950113376],
};
export const WINDOW_INNER_WIDTH = 486;
export const DEBOUNCE_DELAY = 60;
export const MOBILE_LANDSCAPE_OFFSET = 100;
export const SEARCH_SECTION_NAME = 'SEARCH';
export const SECTIONS_WITH_BG_IMAGES = [
  'high_cash',
  'vip_high_cash',
  'bell_link',
  'bell_link_boost',
  'vip_bell_link',
  'vip_bell_link_boost',
  'clover_chance',
  'mystery',
  'progressive',
  'tournaments',
  'instant',
  'gods_and_kings',
  'vip_gods_and_kings',
  'hot_games',
  'cold_games',
  'high_rtp',
];
export const WEBPACK_HASH = String('__webpack_hash__'); // TODO:: Remove this later and use stat.json file from assets app
export const BG_SECTION_COLOR = {
  high_cash: 'rgb(65, 23, 95)',
  vip_high_cash: 'rgb(65, 23, 95)',
  bell_link: 'rgb(26, 0, 0)',
  bell_link_boost: 'rgb(43, 0, 1)',
  gods_and_kings: 'rgb(39,0,0)',
  vip_gods_and_kings: 'rgb(16, 15, 15)',
  vip_bell_link: 'rgb(25, 25, 26)',
  vip_bell_link_boost: 'rgb(16, 13, 14)',
  clover_chance: 'rgb(19, 60, 20)',
  mystery: 'rgb(19, 60, 20)',
  progressive: 'rgb(139, 45, 3)',
  tournament: 'rgb(60, 0, 16)',
  instant: 'rgb(16, 10, 49)',
  premium_link: 'rgb(139, 45, 3)',
  hot_games: 'rgb(33, 1, 1)',
  cold_games: 'rgb(1, 17, 33)',
  high_rtp: 'rgb(29, 13, 46)',
};

export const GAME_FEATURES = {
  HIGH_RTP: 'High RTP',
};

export const JACKPOT_NAMES = {
  BELL_LINK: 'Bell Link',
  BELL_LINK_BOOST: 'Bell Link Boost',
  HIGH_CASH: 'High Cash',
  INSTANT_LINK: 'InstantLink',
  CLOVER_CHANCE: 'Clover Chance',
  VIP_BELL_LINK: 'VIP Bell Link',
  VIP_BELL_LINK_BOOST: 'VIP Bell Link Boost',
  VIP_HIGH_CASH: 'VIP High Cash',
  PROGRESSIVE: 'progressive',
  TOURNAMENT: 'TOURNAMENT',
  TOURNAMENT_INBET: 'tournament_inbet',
  GODS_AND_KINGS: 'Gods And Kings',
  VIP_GODS_AND_KINGS: 'VIP Gods And Kings',
  PREMIUM_LINK: 'Premium Link',
};

export const SECTION_NAMES = {
  ALL_GAMES: 'ALL_GAMES',
  NEW_GAMES: 'NEW_GAMES',
  MYSTERY: 'MYSTERY',
  MOST_PLAYED: 'MOST_PLAYED',
  TOP_GAMES: 'TOP_GAMES',
  TRENDING: 'TRENDING',
  TRENDING_GAMES: 'TRENDING_GAMES',
  TOP: 'TOP',
  PROGRESSIVE: 'PROGRESSIVE',
  HIGH_CASH: 'HIGH_CASH',
  HIGH_RTP: 'HIGH_RTP',
  BELL_LINK: 'BELL_LINK',
  BELL_LINK_BOOST: 'BELL_LINK_BOOST',
  VIP_BELL_LINK: 'VIP_BELL_LINK',
  VIP_BELL_LINK_BOOST: 'VIP_BELL_LINK_BOOST',
  VIP_HIGH_CASH: 'VIP_HIGH_CASH',
  EGYPTIAN: 'EGYPTIAN',
  FRUITS: 'FRUITS',
  CLASSIC: 'CLASSIC',
  BUY_BONUS: 'BUY_BONUS',
  TOURNAMENTS: 'TOURNAMENTS',
  TOURNAMENT_INBET: 'TOURNAMENT_INBET',
  GODS_AND_KINGS: 'GODS_AND_KINGS',
  VIP_GODS_AND_KINGS: 'VIP_GODS_AND_KINGS',
  DICE_SLOT_GAMES: 'DICE_SLOT_GAMES',
  CASH_HEAT_GAMES: 'CASH_HEAT_GAMES',
  PRIZE_POP: 'PRIZE_POP',
  PREMIUM_LINK: 'PREMIUM_LINK',
  TOP_WIN_GAMES: 'TOP_WIN_GAMES',
  HOT_GAMES: 'HOT_GAMES',
  COLD_GAMES: 'COLD_GAMES',
  NEW_REL: 'NEW_REL',
  NEW_RELEASES: 'NEW_RELEASES',
  REBATE: 'REBATE',
};

export const SPJ_JACKPOT_GAMES: string[] = [
  '20 Super Hot',
  '40 Super Hot',
  'Burning Hot',
  'Versailles Gold',
  'Rise of Ra',
];

export const VERTICAL_JP_BADGES = [
  'bell_link',
  'bell_link_boost',
  'clover_chance',
  'gods_and_kings',
  'vip_gods_and_kings',
  'high_cash',
  'vip_bell_link',
  'vip_bell_link_boost',
  'vip_high_cash',
  'high_rtp',
  'premium_link',
];

export const HORIZONTAL_JP_BADGES = [
  '20_super_hot',
  '40_super_hot',
  'burning_hot',
  'instantlink',
  'rise_of_ra',
  'versailles_gold',
];

export const ALL_JP_BADGES = [...VERTICAL_JP_BADGES, ...HORIZONTAL_JP_BADGES];

/** array containing all games with support for animated banners */
export const GAMES_WITH_ANIMATED_BANNERS: string[] = [];

// Tournaments constants
export const TOURNAMENTS_API_URLS = {
  PREFIX: 'tournamentservice/api/game-client/tournaments/',
  GET_TOURNAMENT: 'get-all',
  GET_LEADERBOARD: '/leader-board',
  JOIN_TOURNAMENT: 'join',
};

export const TOURNAMENT_JOIN_REQUEST_ERROR_CODES = {
  401: 'UNAUTHORIZED',
  402: 'PLAYER_EXISTS',
  403: 'MORE_THEN_ONE',
  404: 'NOT_FOUND',
  405: 'JOINING_NOT_PERMITTED',
  406: 'ALREADY_OPTED_OUT',
  407: 'PLAYER_MISSING',
  408: 'PRIZE_NOT_FOUND',
  409: 'UNKNOWN_TYPE',
};

export const COLOR_PRIORITY_OF_TOURNAMENT_CARDS = ['GOLD', 'PURPLE', 'RED', 'BLUE', 'GREEN'];
export const STATUS_PRIORITY_OF_TOURNAMENT_CARDS = [
  'ACTIVE',
  'PROMO',
  'FINISHED',
  'AWARDING_VISIBLE',
  'COMPLETED_VISIBLE',
];

export const MAX_TOURNAMENT_RANKING_PLACE = 100;
export const TOURNAMENT_TABS = {
  Games: 'Games',
  Rewards: 'Rewards',
  Ranking: 'Ranking',
  Rules: 'Rules',
};

export const INGAME_CAMPAIGN_TABS = {
  PRIZE_POP: SECTION_NAMES.PRIZE_POP,
  TOURNAMENTS: SECTION_NAMES.TOURNAMENTS,
  REBATE: SECTION_NAMES.REBATE,
};

/**
 * START OF USER INFO SECTION DATA AND TYPES
 */

export const UserDataTypes = {
  ID: 'ID',
  SCORE: 'Score',
  POSITION: 'Position',
};

export const DEFAULT_NO_VALUE = 'N/A';

/**
 * END OF USER INFO SECTION DATA AND TYPES
 */

// Google Analytics events
export const EVENT_NAMES = {
  LOBBY_EXIT: 'lobbyExit',
  LOBBY_SECTION_OPEN: 'lobbySectionOpen',
  SEARCH_ACTIVATED: 'searchActivated',
  SEARCH_INPUT: 'searchInput',
  SETTINGS_OPENED: 'settingsOpened',
  SETTINGS_SUBMENU_OPENED: 'settingsSubmenuOpened',
  OPEN_GAME: 'openGame',
  OPEN_GAME_FROM_TOURNAMENTS: 'openGameFromTournaments',
  OPEN_TOURNAMENTS_MORE_GAMES_FROM_ALL: 'openTournamentsMoreGamesFromAll',
  OPEN_TOURNAMENTS_GAMES_FROM_CUP: 'openTournamentsGamesFromCup',
  OPEN_TOURNAMENTS_RULES_TAB: 'openTournamentsRulesTab',
  OPEN_TOURNAMENTS_TERMS_AND_CONDITIONS: 'openTournamentsTermsAndConditions',
  TOURNAMENTS_GAMES_SCROLL_DEPTH: 'tournamentsGamesScrollDepth',
};
